import { REMOVE_CLIENT } from "../../CONSTANTS";

export default function removeClient({ id }) {
  return {
    type: REMOVE_CLIENT,
    payload: {
      id,
    },
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/clients/removeClient.js